import React, { useState } from "react"
import { useNavigate } from "react-router-dom"
import { confirmSignIn } from "aws-amplify/auth"
import { useGeneralContext } from "../../Contexts/GeneralContext/GeneralProvider"
import { ConfirmPasswordInterface } from "../../Interfaces/ComponentsInterfaces/LoginPageInterface"
import LinkClassLogo from '../../Assets/LinkClassLogo.png'
import '../../Views/LoginPage/LoginPage.css'
import { TranslatePasswordError } from "../../Helpers/TranslateHelpers"


function ConfirmPasswordModal({ setLoginModal, loginUserName }: ConfirmPasswordInterface) {

	const { handleLogin } = useGeneralContext()

	const navigate = useNavigate()

	const [newPassword, setNewPassword] = useState<string>('')
	const [isRevealingPassword, setIsRevealingPassword] = useState<boolean>(false)
	const [userMessage, setUserMessage] = useState<string>('')


	const handleConfirmPassword = async () => {
		setUserMessage('')
		try {
			await confirmSignIn({ challengeResponse: newPassword })
		} catch (error: any) {
			setUserMessage(TranslatePasswordError(error?.message))
			return
		}

		// The new password was accepted, so a failure past this point is not a password problem.
		try {
			await handleLogin(loginUserName)
		} catch (error) {
			console.error('Session setup failed after confirming the new password:', error)
			setUserMessage('Tu contraseña se guardó, pero no pudimos cargar tus datos. Revisa tu conexión e intenta nuevamente.')
		}
	}

	const handlePasswordChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		e.preventDefault()
		setNewPassword(e.target.value)
	}

	const handleReturnToLanding = () => {
		navigate('/')
	}


	return (
		<div className="InternalDiv">
			<div className="LoginLogoDiv" onClick={handleReturnToLanding}>
				<img src={LinkClassLogo} alt="LinkClassLogo" />
			</div>
			<h1>Crear contraseña</h1>
			{userMessage && <p className="LoginMessage">{userMessage}</p>}

			<div className="LoginPassWordInput">
				<input
					type={isRevealingPassword ? "text" : "password"}
					value={newPassword}
					placeholder="Contraseña"
					onChange={handlePasswordChange}
					onKeyDown={(e) => {
						if (e.key === 'Enter') {
							e.preventDefault();
						}
					}}
				/>
				<button type="button" onClick={() => setIsRevealingPassword(!isRevealingPassword)}>
					{isRevealingPassword ? "Ocultar Contraseña" : "Mostrar contraseña"}
				</button>
			</div>

			<div className="LostPasswordButtonDiv">
				<button
					type="button"
					onClick={() => setLoginModal('Login')}
				>
					Cancelar
				</button>
				<button
					type='button'
					onClick={handleConfirmPassword}
				>
					Confirmar nueva contraseña
				</button>
			</div>
		</div>
	)
}

export default ConfirmPasswordModal